import React from 'react';
import { useSelector } from 'react-redux';

import AlertPanel from 'components/AlertPanel';
import ToolsetPlaceholderComponent from 'components/ToolsetPlaceholder/Component';
import {
  CHI_SQUARE_TEST_FOR_INDEPENDENCE,
  CHI_SQUARE_TEST_FOR_HOMOGENEITY,
  CHI_SQUARE_GOODNESS_OF_FIT,
  ANOVA
} from '../../Constants';

import { getInferentialStatistics } from 'store/form/inferentialStatistics/selectors';
import {
  getFrequencyDataSetLength,
  getVisibleNumericalSelectedParametersNames,
  getVisibleCategoricalSelectedParametersNames
} from 'store/dataset';

import { isNumericalAndCategoricalAnovaChosen, isAnovaModeDatasetContainsRawData } from 'store/form/inferentialStatistics/anova';


const possibleAlertMessage = {
  ANOVA: 'To run an ANOVA test, select one numerical and one categorical variable in Settings in the left panel.',
  CHI_SQUARE_GOODNESS_OF_FIT: 'To generate a Chi-Square Goodness-of-Fit test, select a frequency table on the Dataset page.',
  CHI_SQUARE_TEST_FOR_INDEPENDENCE: 'To generate a Chi-Square Test for Independence, select a 2-way contingency table on the Dataset page.',
  CHI_SQUARE_TEST_FOR_HOMOGENEITY: 'To generate a Chi-Square Test for Homogeneity, select a 2-way contingency table on the Dataset page.'
};

const Alert = () => {
  const frequencyDataSetLength = useSelector(state => getFrequencyDataSetLength(state));
  const numericalDataSetLength = useSelector(state => getVisibleNumericalSelectedParametersNames(state).length);
  const categoricalDataSetLength = useSelector(state => getVisibleCategoricalSelectedParametersNames(state).length);
  const dropdownProcedureValue = useSelector(state => getInferentialStatistics(state));
  const isAnovaFieldsChosen = useSelector(state => isNumericalAndCategoricalAnovaChosen(state));
  const isAnovaModeDataSetScenario = useSelector(state => isAnovaModeDatasetContainsRawData(state));

  const showAlertAnova =
    dropdownProcedureValue === ANOVA &&
    frequencyDataSetLength === 0 &&
    isAnovaModeDataSetScenario &&
    !isAnovaFieldsChosen &&
    numericalDataSetLength > 0 && categoricalDataSetLength > 0;

  const showAlertChiSquare =
    (
      // for 3 cases (show Alert for none contingency datasets)
      // dataset isn't chosen or dataset is regular one or dataset is frequency table
      dropdownProcedureValue === CHI_SQUARE_TEST_FOR_INDEPENDENCE && frequencyDataSetLength < 2
    ) || (
      // for 3 cases (show Alert for none contingency datasets)
      // dataset isn't chosen or dataset is regular one or dataset is frequency table
      dropdownProcedureValue === CHI_SQUARE_TEST_FOR_HOMOGENEITY && frequencyDataSetLength < 2
    ) || (
      // for 2 cases:
      // dataset isn't chosen or dataset is regular one
      dropdownProcedureValue === CHI_SQUARE_GOODNESS_OF_FIT && frequencyDataSetLength === 0
    );

  return (
    <>
      { showAlertAnova && (
        <AlertPanel
          variant="info"
          errMsg={possibleAlertMessage.ANOVA}
          className="mt-5"
        />)
      }
      {
        showAlertChiSquare && (
          <div style={{ padding: '15px', background: 'white' }}>
            <ToolsetPlaceholderComponent message={possibleAlertMessage[dropdownProcedureValue]} />
          </div>
        )
      }
    </>
  );
};

export default Alert;
